<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 18:23:47
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-15 11:02:02
 * @Description: 审核记录
 -->

<template>
  <div class="check-record-wrapper">
    <template v-if="imgList.length > 0">
      <img :src="item" alt="" srcset="" v-for="(item, index) in imgList" :key="index" />
    </template>
    <template v-else>
      <div class="no-data">
        暂无数据
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'check-record',
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {
          checkList: {}
        };
      }
    }
  },
  computed: {
    imgList() {
      return this.propsData.checkList;
    }
  }
};
</script>
<style lang="less" scoped>
.check-record-wrapper {
  padding: 40px;
  img {
    display: block;
    margin: 10px auto;
    width: 50%;
  }
  .no-data {
    min-height: 300px;
    line-height: 300px;
    font-size: 30px;
    text-align: center;
    color: #ccc;
  }
}
</style>
